module.exports = __webpack_public_path__ + "static/OR1s-559c71f5315bbdd2db69958870cca37a.jpg";